import { useReportTemplates } from "../lib";
import ReportTemplateCard from "./ReportTemplate";
import { ReportTemplateType } from "@/constants";
import CreateReportDialog from "./CreateReportDialog";
import { postTrackingData } from "@/api/endpoints/track";
import { useState } from "react";

export default function ReportTemplates() {
  // Local state
  const [template, setTemplate] = useState<ReportTemplateType>();
  const [isNewReportDialogOpen, setIsNewReportDialogOpen] =
    useState<boolean>(false);

  // Helpers
  const reportTemplates = useReportTemplates();

  return (
    <>
      <div className="grid grid-cols-1 gap-3.5 @3xl/main:gap-4 @3xl/main:grid-cols-2 @5xl/main:grid-cols-3 @5xl/main:gap-6">
        {reportTemplates.map((template) => (
          <ReportTemplateCard
            key={template.id}
            template={template}
            onClick={(type) => {
              postTrackingData("Click on new report template link", {
                templateName: type,
              });

              setTemplate(type);
              setIsNewReportDialogOpen(true);
            }}
          />
        ))}
      </div>

      <CreateReportDialog
        template={template!}
        open={isNewReportDialogOpen}
        onClose={() => {
          setIsNewReportDialogOpen(false);

          setTimeout(() => {
            setTemplate(undefined);
          }, 200);
        }}
      />
    </>
  );
}
